import { cloneDeep } from 'lodash';

/**
 * There can be an arbitrary number of items in the "system user" collections.
 * As of 9/26/18, the compromise between showing all possible items with some
 * arbitrary limit, and making all those editable, is to show the first item
 * of a particular type and make that editable. Hence, "get first of" and
 * "set first of".
 */
export default {
  methods: {
    getFirstOf(type = 'work', collection = []) {
      let coll = collection;
      if (coll === null) coll = [];
      return coll.find(el => el.type === type) || {};
    },

    /**
     * Text to display in user details collapsable sections when users in an
     * organization are not allowed to edit their personal data.
     */
    getUserFieldsReadOnlyText() {
      return 'These fields are set to read-only for your users and they must contact you to make changes.  Go to the [settings](#/settings) tab to turn this off.';
    },

    /**
     * @param {*} newValue - passed from InputValidatorModel event, the value to change to
     * @param {string} attribute - passed from InputValidatorModel event, attribute of user
     *                           object to change
     * @param {array} collection - The collection holding the item to modify.
     * @param {string} type - The data "type". ie: work, home, custom, work_mobile, mobile, etc.
     *                      { type: 'home', pobox: 12345-1111, streetAddress: '45 Sycamore Lane' }
     */
    setFirstOf(newValue, attribute) {
      const setItem = this.setItemField;
      return (collection = [], type = 'work') => {
        let coll = collection;

        if (coll === null) coll = [];

        coll = cloneDeep(coll);

        const item = this.getFirstOf(type, coll);

        item[attribute] = newValue;

        if (!item.type) {
          item.type = type;
          coll.push(item);
        }

        setItem(attribute, coll);

        return coll;
      };
    },
  },
};
